import _classCallCheck from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import Shareable from '@shared/models/shareable';
import Person, { NullPerson } from '@shared/models/person';
import BusySpan from '@shared/models/busy_span';
import ImportedCalendar from '@shared/models/imported_calendar';
import BusySpanCalendarEvents from '@shared/models/busy_span_calendar_events';
import { NullCalendarEvent } from '@shared/models/calendar_event';
import CalendarColorCycler from '@shared/services/calendar_color_cycler';

var Me = /*#__PURE__*/function (_Shareable) {
  _inherits(Me, _Shareable);

  var _super = _createSuper(Me);

  function Me() {
    _classCallCheck(this, Me);

    return _super.apply(this, arguments);
  }

  _createClass(Me, [{
    key: "isSignedIn",
    value: function isSignedIn() {
      return true;
    }
  }, {
    key: "equals",
    value: function equals(person) {
      return this.person.equals(person);
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.person.name;
    }
  }, {
    key: "getVisibleImportedCalendars",
    value: function getVisibleImportedCalendars() {
      return this.importedCalendars.filter(function (calendar) {
        return calendar.visible;
      });
    }
  }, {
    key: "hasImportedCalendars",
    value: function hasImportedCalendars() {
      return this.importedCalendars.length > 0;
    }
  }, {
    key: "isBusySpanPublic",
    value: function isBusySpanPublic(busySpan) {
      var _this = this;

      if (!this.isBusySpanImported(busySpan)) {
        return true;
      }

      return this.getVisibleImportedCalendars().some(function (_ref) {
        var id = _ref.id;
        return id === _this.getCalendarEventFromBusySpan(busySpan).calendarID;
      });
    }
  }, {
    key: "getCalendarEventFromBusySpan",
    value: function getCalendarEventFromBusySpan(busySpan) {
      return this.busySpanCalendarEvents.get(busySpan.id) || new NullCalendarEvent();
    }
  }, {
    key: "getCalendarColor",
    value: function getCalendarColor(calendarID) {
      var position = this.importedCalendars.findIndex(function (_ref2) {
        var id = _ref2.id;
        return id === calendarID;
      });

      if (position === -1) {
        return;
      }

      var colors = new CalendarColorCycler();
      return colors.getColorAtPosition(position);
    }
  }, {
    key: "isBusySpanImported",
    value: function isBusySpanImported(busySpan) {
      return !this.getCalendarEventFromBusySpan(busySpan).isNull();
    }
  }, {
    key: "hasBusySpans",
    value: function hasBusySpans() {
      return this.busySpans.length > 0;
    }
  }, {
    key: "getImportedCalendarNameFromBusySpan",
    value: function getImportedCalendarNameFromBusySpan(busySpan) {
      var calendarID = this.getCalendarEventFromBusySpan(busySpan).calendarID;
      var importedCalendar = this.importedCalendars.find(function (_ref3) {
        var id = _ref3.id;
        return id === calendarID;
      });
      return importedCalendar.summary || calendarID;
    }
  }, {
    key: "withImportedCalendars",
    value: function withImportedCalendars(importedCalendars) {
      var clone = this.clone();
      clone.importedCalendars = importedCalendars;
      return clone;
    }
  }], [{
    key: "fromPlainObject",
    value: function fromPlainObject(obj) {
      if (!obj) {
        return new NullMe();
      }

      var importedCalendars = obj.importedCalendars,
          person = obj.person,
          email = obj.email,
          busySpans = obj.busySpans,
          busySpanCalendarEvents = obj.busySpanCalendarEvents;
      var me = new this();
      me.importedCalendars = Array.isArray(importedCalendars) ? importedCalendars.map(ImportedCalendar.fromPlainObject, ImportedCalendar) : [];
      me.person = Person.fromPlainObject(person);
      me.email = email;
      me.busySpans = Array.isArray(busySpans) ? busySpans.map(BusySpan.fromPlainObject, BusySpan) : [];
      me.busySpanCalendarEvents = BusySpanCalendarEvents.fromPlainObject(busySpanCalendarEvents);
      return me;
    }
  }, {
    key: "shareableFields",
    value: function shareableFields() {
      return ['importedCalendars', 'person', 'email', 'busySpans', 'busySpanCalendarEvents'];
    }
  }]);

  return Me;
}(Shareable);

export { Me as default };
export var NullMe = /*#__PURE__*/function (_Me) {
  _inherits(NullMe, _Me);

  var _super2 = _createSuper(NullMe);

  function NullMe() {
    var _this2;

    _classCallCheck(this, NullMe);

    _this2 = _super2.call(this);
    _this2.person = new NullPerson();
    _this2.email = '';
    _this2.busySpans = [];
    _this2.importedCalendars = [];
    return _this2;
  }

  _createClass(NullMe, [{
    key: "isNull",
    value: function isNull() {
      return true;
    }
  }, {
    key: "isSignedIn",
    value: function isSignedIn() {
      return false;
    }
  }, {
    key: "equals",
    value: function equals(person) {
      return false;
    }
  }, {
    key: "hasImportedCalendars",
    value: function hasImportedCalendars() {
      return false;
    }
  }, {
    key: "getCalendarEventFromBusySpan",
    value: function getCalendarEventFromBusySpan(busySpan) {
      return new NullCalendarEvent();
    }
  }]);

  return NullMe;
}(Me);